module.exports = __webpack_public_path__ + "img/nav_class.c0d024e9.png";